import Navigator from 'app';
import navlinkModel from './navlink_model';
import 'select';
var NavlinkCollection = Backbone.Collection.extend({
  model: navlinkModel,
  initialize: function navlinkCollectionInitialize(models) {
    Backbone.Select.One.applyTo(this, models);
  }
});
Navigator._initializeNavlinks = function () {
  return new NavlinkCollection([{
    name: "HOME",
    url: "",
    navigationTrigger: "welcome:show"
  }, {
    name: "BILLS",
    url: "bills",
    navigationTrigger: "bill:home:show"
  }, {
    name: "MEMBERS",
    url: "members",
    navigationTrigger: "member:home:show"
  }, {
    name: "JOURNAL",
    url: "journal",
    navigationTrigger: "journal:home:show"
  }, {
    name: "ABOUT",
    url: "about",
    navigationTrigger: "about:show"
  }]);
};
var API = {
  getNavlinks: function () {
    return Navigator._initializeNavlinks();
  }
};
Navigator.reqres.setHandler("navlinks", function navlinkRequestHandler() {
  return API.getNavlinks();
});
export { NavlinkCollection as default };